import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export const useCreateLegalEntity = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base
        .post('/api/legalentity', model)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], old => old ? [...old, result] : [result]);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { createLegalEntity: mutateAsync, isLoading };
};
